import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { ChartPie } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PALETTE = ['#002FA7', '#2E7D32', '#EF6C00', '#9C27B0', '#D32F2F', '#1565C0',
                 '#E65100', '#6A1B9A', '#00838F', '#F57F17', '#5D4037', '#546E7A'];

const ProjectDistributionCharts = ({ compact = false }) => {
  const [data, setData] = useState({ items: [], total_expenses_ht: 0, total_hours: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axios.get(`${API_URL}/api/projects/stats/distribution`, { withCredentials: true });
        if (mounted) setData(res.data);
      } catch (e) { /* ignore */ }
      finally { if (mounted) setLoading(false); }
    })();
    return () => { mounted = false; };
  }, []);

  if (loading) return <div style={{ padding: '24px', color: '#5E5F66' }}>Chargement...</div>;

  const expensesData = data.items.filter(i => i.expenses_ht > 0).map(i => ({ name: i.name, value: i.expenses_ht }));
  const hoursData = data.items.filter(i => i.hours > 0).map(i => ({ name: i.name, value: i.hours }));

  const Card = ({ title, unit, chartData, total }) => (
    <div style={{ flex: 1, minWidth: '320px', background: 'white', border: '1px solid #E2E2E6', borderRadius: '10px', padding: '18px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
        <ChartPie size={18} color="#002FA7" weight="fill" />
        <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '700' }}>{title}</h4>
      </div>
      <div style={{ fontSize: '1.4rem', fontWeight: '800', color: '#002FA7', marginBottom: '6px' }}>
        {unit === 'EUR'
          ? `${(total || 0).toLocaleString('fr-FR', { maximumFractionDigits: 2 })} EUR`
          : `${(total || 0).toFixed(1)} h`}
      </div>
      {chartData.length === 0 ? (
        <div style={{ padding: '40px', textAlign: 'center', color: '#9A9AA0', fontSize: '0.85rem' }}>Aucune donnée</div>
      ) : (
        <ResponsiveContainer width="100%" height={compact ? 220 : 280}>
          <PieChart>
            <Pie data={chartData} dataKey="value" nameKey="name" cx="50%" cy="50%"
                 outerRadius={compact ? 70 : 95} label={(e) => `${e.name} (${((e.value / total) * 100).toFixed(0)}%)`}>
              {chartData.map((entry, i) => <Cell key={i} fill={PALETTE[i % PALETTE.length]} />)}
            </Pie>
            <Tooltip formatter={(v) => unit === 'EUR'
              ? `${Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 2 })} EUR`
              : `${Number(v).toFixed(1)} h`} />
            {!compact && <Legend verticalAlign="bottom" wrapperStyle={{ fontSize: '0.75rem' }} />}
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );

  return (
    <div data-testid="project-distribution-charts" style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
      <Card title="Dépenses par chantier (HT)" unit="EUR" chartData={expensesData} total={data.total_expenses_ht} />
      <Card title="Heures par chantier" unit="h" chartData={hoursData} total={data.total_hours} />
    </div>
  );
};

export default ProjectDistributionCharts;
